import styled from 'styled-components';
import { IconMessageOutline, mediaBreakpointMixin, Spacer, Spinner, TextButton, token } from '@zillow/constellation';
import { useQuery } from '@apollo/client';
import useQueryVariables from '../../../hooks/useQueryVariables';
import { useSelector } from 'react-redux';
import { propertyIdSelector } from '../../../selectors';
import { getMessageConversationId, MESSAGE_RACHEL_QUERY } from '../../../utils/messageRachel';
import { getMessageConversationPath } from '../../../constants/urls';
import { getApplicants, getPrimaryApplicant } from '../../../utils/applicants';
import { getTitleCase } from '../../../utils/formatLogicUtil';
import { useApplicationSummaryContext } from '../../../contexts/ApplicationSummaryContext';
import { useListingUser } from '../../../hooks/useListingUser';
import { emitMessageRachelEvent } from '../../../../client/analytics/clickstreamEvents';

const StyledSpacer = styled(Spacer)`
  border-top: 1px solid ${token('colors.borderLight')};

  @media ${mediaBreakpointMixin('lg')} {
    border-top: none;
  }
`;

function MessageRachelManager() {
  const { isApplicationDeclined } = useApplicationSummaryContext();
  const variables = useQueryVariables();
  const { data, loading, error } = useQuery(MESSAGE_RACHEL_QUERY, { variables });
  const applicants = getApplicants(data);
  const primaryApplicant = getPrimaryApplicant(applicants);
  const messageConversationId = getMessageConversationId(primaryApplicant);
  const propertyId = useSelector(propertyIdSelector);
  const hasConversationId = Boolean(messageConversationId);
  const { user, listing } = useListingUser();

  if (loading) {
    return (
      <Spinner size="sm" marginRight="lg" id="mrm__spinner">
        <title>Loading messages</title>
      </Spinner>
    );
  }

  const buttonText = isApplicationDeclined
    ? 'View messages'
    : `Message ${getTitleCase(primaryApplicant?.contactInfo?.firstName)}`;

  return (
    !loading &&
    !error &&
    hasConversationId && (
      <StyledSpacer paddingTop={{ default: 'md', lg: 0 }}>
        <TextButton
          id="mrm__text-button"
          marginRight={{ default: 'unset', lg: 'xs' }}
          as="a"
          href={getMessageConversationPath(propertyId, messageConversationId)}
          icon={<IconMessageOutline />}
          onClick={() => emitMessageRachelEvent(listing, user)}
        >
          {buttonText}
        </TextButton>
      </StyledSpacer>
    )
  );
}

export default MessageRachelManager;
